import React from "react";
import styled from "styled-components";

interface OnboardingAnnouncementBarProps {
  value: number;
  onClick: () => void;
  messagePrefix?: string;
  messageText?: string;
  buttonLabel?: string;
  className?: string;
}

const OnboardingProgressCircleWrapper = styled.div`
  position: relative;
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: 500;
  color: #222222;

  svg {
    position: absolute;
    inset: 0;
  }

  span {
    position: relative;
    z-index: 1;
  }
`;

const OnboardingProgressCircle: React.FC<{ value: number }> = ({ value }) => {
  const clamped = Math.max(0, Math.min(100, value));
  const size = 30;
  const strokeWidth = 3;
  const center = size / 2;
  const radius = center - strokeWidth / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - clamped / 100);

  return (
    <OnboardingProgressCircleWrapper>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        {/* Define the gradient in <defs> */}
        <defs>
          <linearGradient id="progressGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#FF6D41" />
            <stop offset="53.16%" stopColor="#FF6D41" />
            <stop offset="81.73%" stopColor="#FF6D41" />
            <stop offset="100%" stopColor="#DD4B39" />
          </linearGradient>
        </defs>
        
        {/* Background circle */}
        <circle
          cx={center}
          cy={center}
          r={radius}
          stroke="#fef0e1"
          strokeWidth={strokeWidth}
          fill="#fff6eb"
        />
        
        {/* Progress circle with gradient stroke */}
        <circle
          cx={center}
          cy={center}
          r={radius}
          stroke="url(#progressGradient)"  // ✅ Reference the gradient
          strokeWidth={strokeWidth}
          fill="transparent"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform={`rotate(-90 ${center} ${center})`}
        />
      </svg>
      <span>{Math.round(clamped)}%</span>
    </OnboardingProgressCircleWrapper>
  );
};

const AnnouncementBar = styled.div`
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.65rem 2.5rem;
  // border-top: 1px solid #F59E0B80;
  border-top: 1px solid rgba(245, 158, 11, 0.5);
  background: rgb(245 158 11 / 20%);
  border-bottom: 1px solid rgba(245, 158, 11, 0.5);
  font-size: 0.8rem;
`;

const AnnouncementMessage = styled.p`
  flex: 1;
  margin: 0;
  color: rgba(30, 30, 30, 1);
  span {
    color: rgba(88, 85, 88, 1)
  }
`;

const AnnouncementButton = styled.button`
  padding: 0.4rem 1rem;
  border-radius: 4px;
  border: 1px solid rgba(245, 158, 11, 0.2);
  background: #ffffff;
  color: rgba(30, 30, 30, 1);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
`;

const OnboardingAnnouncementBar: React.FC<OnboardingAnnouncementBarProps> = ({
  value,
  onClick,
  messagePrefix = "Your L2 needs some mandatory details to complete your onboarding.",
  messageText = "Please complete the onboarding form to proceed.",
  buttonLabel = "Complete your onboarding",
  className,
}) => {
  return (
    <AnnouncementBar className={className}>
      {/* <OnboardingProgressCircle value={value} /> */}
      <AnnouncementMessage>
        <strong> {messagePrefix}</strong>&nbsp;
        <span>{messageText}</span>
      </AnnouncementMessage>
      {/* <AnnouncementButton
        type="button"
        onClick={onClick}
      >
        {buttonLabel}
      </AnnouncementButton> */}
    </AnnouncementBar>
  );
};

export default OnboardingAnnouncementBar;